import Player from "@vimeo/player";
import React, { useRef, useState, useEffect } from "react";
import { clickTrackLog } from "../services/clickTrack.service";

export const VimeoPlayer = (props) => {
  const [played, setPlayed] = useState(false);
  const iframeRef = useRef(null);
  const playedRef = useRef();

  playedRef.current = played;

  const { url, eventId, exhibitorId, clientKey, clickTrack = true } = props;

  useEffect(() => {
    const player = new Player(iframeRef.current);
    player.on("play", function () {
      if (playedRef.current) return;
      setPlayed(true);
      clickTrackLog(eventId, exhibitorId, clientKey, "VimeoVideo", url, "Exhibitor");
    });

    return () => {
      iframeRef.current = null;
    };
  }, []);

  return <iframe allowFullScreen={true} style={{ width: "100%", height: "100%", border: "0px" }} allow="autoplay; fullscreen; picture-in-picture" allowfullscreen ref={iframeRef} src={url} />;
};
